import React, { useEffect } from "react";
import Header from "../../UIElements/Header";

function PageNotFound() {
  return (
    <>
      <Header />
    <div>
      Page Not Found :(
    </div>
    </>
  );
}

export { PageNotFound };